module.exports = __webpack_public_path__ + "img/germany.416594b5.svg";